/* globals $ */
import * as Helpers from '../utils/Helpers';

/**
 * This class will setup all ajax request to contain the token header
 */

class CSRF {
  constructor() {
    this.CSRFToken = Helpers.getCookie('cs');
  }

  setHeader() {
    $.ajaxSetup({
      beforeSend: (xhr, settings) => {
        if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type) && !this.crossDomain) {
          xhr.setRequestHeader('X-CSRF-Token', this.CSRFToken);
        }
      },
    });
  }
}

export default CSRF;
